import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Доступ к анализу по Петровику (/metrica) есть только у пользователей
 * с пометкой petrovich_access (или у администраторов). Остальных отправляем
 * на страницу контактов — там указана почта для связи по вопросу доступа.
 */
const PetrovichRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen paper-texture flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#C41E3A] mx-auto mb-4"></div>
          <p className="text-lg">Проверка доступа...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.is_admin && !user.petrovich_access) {
    return <Navigate to="/contacts" replace />;
  }

  return children;
};

export default PetrovichRoute;
